const CHUNK_RELOAD_KEY_PREFIX = 'hv:chunk-load-reload:';
const CHUNK_RELOAD_QUERY_PARAM = '__hv_reload';

const CHUNK_LOAD_ERROR_PATTERNS = [
  /failed to fetch dynamically imported module/i,
  /importing a module script failed/i,
  /loading chunk \d+ failed/i,
  /chunkloaderror/i,
  /error loading dynamically imported module/i,
  /not a valid JavaScript MIME type/i,
  /expected a JavaScript.*module script/i,
  /MIME type of ['"]text\/html['"]/i,
];

const getErrorText = (error: unknown): string => {
  if (error instanceof Error) {
    return `${error.name} ${error.message}`;
  }

  if (typeof error === 'string') {
    return error;
  }

  if (error && typeof error === 'object') {
    const maybeReason = 'reason' in error ? (error as { reason?: unknown }).reason : null;
    const maybeMessage = 'message' in error ? (error as { message?: unknown }).message : null;
    return [getErrorText(maybeReason), getErrorText(maybeMessage)].join(' ');
  }

  return '';
};

export const isChunkLoadError = (error: unknown): boolean => {
  const text = getErrorText(error);
  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(text));
};

export const clearChunkLoadRecovery = () => {
  if (typeof window === 'undefined') return;

  const prefix = CHUNK_RELOAD_KEY_PREFIX;
  Object.keys(window.sessionStorage)
    .filter((key) => key.startsWith(prefix))
    .forEach((key) => window.sessionStorage.removeItem(key));
};

export const reloadForLatestChunk = (): boolean => {
  if (typeof window === 'undefined') return false;

  const reloadKey = `${CHUNK_RELOAD_KEY_PREFIX}${window.location.pathname}`;
  if (window.sessionStorage.getItem(reloadKey) === '1') {
    return false;
  }

  window.sessionStorage.setItem(reloadKey, '1');

  const url = new URL(window.location.href);
  url.searchParams.set(CHUNK_RELOAD_QUERY_PARAM, String(Date.now()));
  window.location.replace(url.toString());
  return true;
};

export const installChunkLoadRecovery = () => {
  if (typeof window === 'undefined') return;

  window.setTimeout(() => {
    clearChunkLoadRecovery();

    const url = new URL(window.location.href);
    if (url.searchParams.has(CHUNK_RELOAD_QUERY_PARAM)) {
      url.searchParams.delete(CHUNK_RELOAD_QUERY_PARAM);
      window.history.replaceState(window.history.state, '', url.toString());
    }
  }, 15000);

  window.addEventListener('error', (event) => {
    if (isChunkLoadError(event.error || event.message)) {
      reloadForLatestChunk();
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event.reason)) {
      reloadForLatestChunk();
    }
  });
};
